package io.github.amanshuraikwar.portfolio

import io.github.amanshuraikwar.portfolio.blog.BlogListDataItem

/**
 * Note: generated by buildWebsite.kts, do not edit!
 */
class GeneratedBlogListDataStore {

	fun getBlogListData(): List<BlogListDataItem> {
		return listOf()
	}
}